<template>
  <div id="app">
    <home></home>
  </div>
</template>

<script>
   import home from '@/views/Home'

   export default {
      components: {
        home
      }
   }
</script>

<style lang="scss">
#app {
  text-align: left;
}
</style>
